module.exports = __webpack_public_path__ + "static/pic02-dc51f3bcc6bdd71d0e881d2a155b1dad.jpg";